// extracted by mini-css-extract-plugin
export default {"name":"profile_label-module___name___ab9fe5c4","root":"profile_label-module___root___bb824a50"};